export default __webpack_public_path__ + "static/media/tool-icon-goal-small.1ee452b1.svg";